/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WalletTotalOfDonations } from '../../models/wallet-total-of-donations';

export interface BookingControllerGetTotalOfDonations$Params {
}

export function bookingControllerGetTotalOfDonations(http: HttpClient, rootUrl: string, params?: BookingControllerGetTotalOfDonations$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTotalOfDonations;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerGetTotalOfDonations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WalletTotalOfDonations;
      }>;
    })
  );
}

bookingControllerGetTotalOfDonations.PATH = '/booking/wallet/total-donations';
